import { useMemo } from 'react';
import { SegmentedButtons, Checkbox } from '@scale/scaleui';

export type Mode = 'editor' | 'diff' | 'preview';

const MODE_OPTIONS: Record<Mode, { value: Mode; label: string }> = {
  editor: { value: 'editor', label: 'Editor' },
  diff: { value: 'diff', label: 'Diff' },
  preview: { value: 'preview', label: 'Preview' },
};

const DEFAULT_MODE_OPTIONS: Mode[] = ['editor', 'diff'];

type Props = {
  selectedMode: Mode;
  modeOptions?: Mode[];
  onModeChange?: (value: Mode) => void;
  showTextDirectionToggle?: boolean;
  rightToLeft?: boolean;
  onTextDirectionChange?: (value: boolean) => void;
};

const ContentTypeSelector = ({
  selectedMode,
  modeOptions = DEFAULT_MODE_OPTIONS,
  onModeChange,
  showTextDirectionToggle = false,
  rightToLeft = false,
  onTextDirectionChange,
}: Props) => {
  const mode = useMemo(() => {
    return modeOptions.map(item => ({
      id: MODE_OPTIONS[item].value,
      label: MODE_OPTIONS[item].label,
    }));
  }, [modeOptions]);

  return (
    <div className="flex flex-1 justify-between">
      {modeOptions.length > 1 && (
        <SegmentedButtons
          selected={selectedMode}
          onSelect={value => onModeChange?.(value as Mode)}
          buttons={mode}
        />
      )}

      {showTextDirectionToggle && selectedMode === 'editor' && (
        <Checkbox
          checked={rightToLeft}
          id="checkbox"
          label="Enable RTL Text"
          onChange={() => onTextDirectionChange?.(!rightToLeft)}
          variant="secondary"
        />
      )}
    </div>
  );
};

export default ContentTypeSelector;
